import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import UpgradeModal from './UpgradeModal';

/**
 * Gates a child page behind the PRO plan. Free users see an upgrade overlay
 * with the feature name; PRO users see the underlying page unchanged. Use
 * around routes where the entire page is meaningless without PRO access
 * (Invoices, Contracts, Payment Tracker, etc.) — see plan-tier strategy.
 */
export default function ProGate({ feature, description, children }) {
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);

  // effectivePlan is the gating signal during the launch promo window — it's
  // "PRO" for everyone whether or not they have a real subscription. After
  // Aug 22 the backend reverts effectivePlan to the user's actual plan, so
  // this check naturally re-engages without code change.
  if (user?.effectivePlan === 'PRO' || user?.plan === 'PRO') return children;

  return (
    <div style={{ padding: '2rem', maxWidth: 900, margin: '0 auto' }}>
      <div style={{
        background: 'linear-gradient(135deg, #faf5ff 0%, #ede9fe 100%)',
        border: '2px solid #c4b5fd',
        borderRadius: 18,
        padding: '3rem 2rem',
        textAlign: 'center',
        marginTop: '1rem',
        boxShadow: '0 10px 30px rgba(139, 92, 246, 0.08)'
      }}>
        <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>🔒</div>

        <div style={{
          display: 'inline-block',
          background: 'linear-gradient(135deg, #8b5cf6, #6366f1)',
          color: 'white',
          fontSize: '0.7rem',
          fontWeight: 800,
          letterSpacing: '0.08em',
          padding: '0.3rem 0.9rem',
          borderRadius: 999,
          marginBottom: '0.85rem'
        }}>PRO FEATURE</div>

        <h1 style={{
          fontFamily: "'Syne', sans-serif",
          fontSize: '1.7rem',
          fontWeight: 800,
          color: '#0a0a0f',
          margin: '0 0 0.6rem'
        }}>
          {feature} is for PRO members
        </h1>

        <p style={{ color: '#475569', fontSize: '0.95rem', margin: '0 auto 2rem', maxWidth: 520, lineHeight: 1.55 }}>
          {description || `Upgrade to PRO to unlock ${feature} and the rest of CreatorKhata's business tools — invoices, contracts, payments, outreach, and more.`}
        </p>

        <button onClick={() => setShowModal(true)} style={{
          padding: '0.85rem 2.5rem',
          background: 'linear-gradient(135deg, #8b5cf6, #6366f1)',
          color: 'white',
          border: 'none',
          borderRadius: 12,
          fontSize: '0.95rem',
          fontWeight: 700,
          cursor: 'pointer',
          boxShadow: '0 6px 18px rgba(139, 92, 246, 0.35)',
          transition: 'transform 0.1s'
        }}
        onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.98)'}
        onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          🚀 Upgrade to PRO — ₹199/month
        </button>

        <div style={{ marginTop: '1rem', fontSize: '0.75rem', color: '#64748b' }}>
          Or ₹1,799/year (save ₹589) · 7-day refund · Cancel anytime
        </div>
      </div>

      {showModal && (
        <UpgradeModal
          feature={feature}
          limit={0}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
}
